<!-- SVG Templates -->
<ng-template #infoSVG>
  <svg
    class="w-3.5 h-3.5 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white cursor-pointer ms-1"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
    />
  </svg>
</ng-template>

<ng-template #acresSVG>
  <svg
    class="w-3 h-3 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fill-rule="evenodd"
      d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-1v3a1 1 0 1 1-2 0v-3h-1v3a1 1 0 1 1-2 0v-3h-1v3a1 1 0 1 1-2 0v-3H7a1 1 0 1 1 0-2h3v-1H7a1 1 0 1 1 0-2h3V8H7a1 1 0 0 1 0-2h3V5a2 2 0 0 0-2-2H5Z"
      clip-rule="evenodd"
    />
  </svg>
</ng-template>

<ng-template #fieldsSVG>
  <svg
    class="w-3 h-3 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fill-rule="evenodd"
      d="M11.906 1.994a8.002 8.002 0 0 1 8.09 8.421 7.996 7.996 0 0 1-1.297 3.957.996.996 0 0 1-.133.204l-.108.129c-.178.243-.37.477-.573.699l-5.112 6.224a1 1 0 0 1-1.545 0L5.982 15.26l-.002-.002a18.146 18.146 0 0 1-.309-.38l-.133-.163a.999.999 0 0 1-.13-.202 7.995 7.995 0 0 1 6.498-12.518ZM15 9.997a3 3 0 1 1-5.999 0 3 3 0 0 1 5.999 0Z"
      clip-rule="evenodd"
    />
  </svg>
</ng-template>

<!-- Summary Manager Dashboard (/manager/dashboard)-->
<div class="flex-1 flex flex-col gap-2">
  @if (showDashboardBanner) {
    <div
      class="relative w-full flex-shrink-0 rounded-lg border border-blue-200 bg-blue-100 px-4 py-2 pr-12 text-center shadow dark:border-blue-400/60 dark:bg-blue-700 md:px-5 md:py-2 md:pr-14"
      role="status"
      aria-live="polite"
    >
      <button
        type="button"
        class="absolute right-3 top-1 inline-flex h-7 w-7 items-center justify-center rounded-lg text-blue-700 transition-colors hover:bg-blue-200 hover:text-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:text-blue-100 dark:hover:bg-blue-600 dark:hover:text-white"
        aria-label="Close dashboard banner"
        (click)="dismissDashboardBanner()"
      >
        <svg
          class="h-3.5 w-3.5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 14 14"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m1 1 12 12M13 1 1 13"
          />
        </svg>
      </button>
      <p class="text-base font-semibold text-blue-900 dark:text-blue-50">
        Data last updated {{ dashboardUpdatedDate || "loading..." }} (Daily)
      </p>
    </div>
  }

  <!-- Top -->
  <div class="flex-[0.43] grid grid-cols-12 gap-2.5">
    <!-- Cards -->
    <div
      #cardsContainer
      class="bg-white dark:bg-gray-800 rounded-lg col-span-3 flex flex-col gap-2 p-2"
    >
      <div class="flex-1 grid grid-cols-4 gap-2">
        <!-- Grower Count -->
        <dl
          class="stat-circle-card bg-orange-100 dark:bg-gray-700 col-span-2 rounded-lg flex flex-col items-center justify-center gap-1 relative"
        >
          <dt
            #growerCircle
            [style.width.px]="circleSize"
            [style.height.px]="circleSize"
            class="stat-circle aspect-square rounded-full bg-orange-200 dark:bg-gray-600 text-orange-700 dark:text-orange-400 font-medium flex items-center justify-center"
          >
            {{ growerCount }}
          </dt>
          <dd
            class="stat-circle-label text-orange-700 dark:text-orange-400 font-medium text-center"
          >
            Users
          </dd>
          <app-graph-popover-instruction
            class="absolute top-2 right-2"
            [placement]="'right'"
          >
            <div class="p-3 space-y-2">
              <h3 class="font-semibold text-gray-900 dark:text-white">Note:</h3>
              <div class="space-y-2 text-gray-700 dark:text-gray-400">
                This represents the total number of users who have claimed
                fields in your management area. Not including users registered
                as part of your management area but have no fields claimed.
              </div>
            </div>
          </app-graph-popover-instruction>
        </dl>
        <!-- Cumulative Avg ET -->
        <dl
          class="stat-circle-card bg-blue-100 dark:bg-gray-700 col-span-2 rounded-lg flex flex-col items-center justify-center gap-1"
        >
          <dt
            #etCircle
            [style.width.px]="circleSize"
            [style.height.px]="circleSize"
            class="stat-circle aspect-square rounded-full bg-blue-200 dark:bg-gray-600 text-blue-700 dark:text-blue-400 font-medium flex items-center justify-center"
          >
            {{ totalETInFt.toFixed(1) }}
          </dt>
          <dd
            class="stat-circle-label text-blue-700 dark:text-blue-400 font-medium text-center"
          >
            Cumulative Avg ET (ac-ft/ac)
          </dd>
        </dl>
      </div>

      <div class="flex-1 grid grid-cols-4 gap-2">
        <!-- Cumulative Avg Precip -->
        <dl
          class="stat-circle-card bg-purple-100 dark:bg-gray-700 col-span-2 rounded-lg flex flex-col items-center justify-center gap-1"
        >
          <dt
            #precipCircle
            [style.width.px]="circleSize"
            [style.height.px]="circleSize"
            class="stat-circle aspect-square rounded-full bg-purple-200 dark:bg-gray-600 text-purple-700 dark:text-purple-300 font-medium flex items-center justify-center"
          >
            {{ totalPrcpInInch.toFixed(1) }}
          </dt>
          <dd
            class="stat-circle-label text-purple-700 dark:text-purple-300 font-medium text-center"
          >
            Cumulative Avg Precip (in)
          </dd>
        </dl>
        <!-- Estimated Cumulative -->
        <dl
          class="stat-circle-card relative bg-teal-100 dark:bg-gray-700 col-span-2 rounded-lg flex flex-col items-center justify-center gap-1"
        >
          <!-- Icon -->
          <app-info-popover
            class="absolute top-2 right-2"
            [infoType]="'estimatedCTC'"
          ></app-info-popover>
          <!-- Main content -->
          <dt
            #consumptionCircle
            [style.width.px]="circleSize"
            [style.height.px]="circleSize"
            class="stat-circle aspect-square rounded-full bg-teal-200 dark:bg-gray-600 text-teal-700 dark:text-teal-400 font-medium flex items-center justify-center"
          >
            {{ this.projectedTotalConsumption.toFixed(1) }}
          </dt>
          <dd
            class="stat-circle-label text-teal-700 dark:text-teal-400 font-medium text-center"
          >
            Estimated Cumulative Total Consumption (TAF)
          </dd>
        </dl>
      </div>
    </div>

    <!-- Water Sources Summary (dummy values until the API is available) -->
    <section
      class="flex min-w-0 flex-col rounded-lg bg-white p-2 dark:bg-gray-800 col-span-3"
    >
      <h5
        class="text-xs 3xl:text-base font-bold leading-none text-gray-900 dark:text-white"
      >
        Water Sources (Inches)
      </h5>
      <div class="min-h-0 flex-1">
        <div
          #waterSourcesChart
          id="water-sources-chart"
          class="h-full w-full bg-white dark:bg-gray-800"
        ></div>
      </div>
    </section>

    <!-- Crops Summary -->
    <div
      class="crop-summary-panel flex min-w-0 flex-col bg-white dark:bg-gray-800 rounded-lg col-span-3 p-3"
    >
      <div class="flex flex-col gap-3">
        <div class="flex flex-col gap-2">
          <!-- Top Row: justify between -->
          <div
            class="crop-summary-header flex justify-between items-center gap-2"
          >
            <!-- Left content -->
            <div class="crop-summary-title flex min-w-0 items-start gap-1">
              <h5 class="font-bold leading-snug text-gray-900 dark:text-white">
                Year to Date Cumulative Avg ET by Crop (ac-ft/ac)
                <app-graph-popover-instruction
                  class="ms-1 inline-flex align-middle"
                  [customSVG]="infoSVG"
                >
                  <div class="p-3 space-y-2">
                    <h3 class="font-semibold text-gray-900 dark:text-white">
                      Note:
                    </h3>
                    <p>
                      This chart represents the top 5 crops (acreage based) in
                      the district/GSA and their associated year-to-date water
                      consumption. The (insert icon of download button) button
                      can be used to download consumption and additional
                      information from all crops claimed in the district/GSA.
                    </p>
                  </div>
                </app-graph-popover-instruction>
              </h5>
            </div>

            <!-- Right content -->
            <div class="crop-summary-date relative flex shrink-0 items-center">
              <div
                class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
              >
                <svg
                  class="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                  />
                </svg>
              </div>
              <input
                #datepickerInput
                id="datepicker-cropSummary"
                maxDateStr
                datepicker-format="yyyy-mm-dd"
                type="text"
                class="crop-summary-date-input bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block ps-9 py-1.5 pe-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Select date"
                [attr.value]="maxDateStr"
                readonly
              />
            </div>
          </div>

          <!-- Second row -->
          <div
            class="crop-summary-actions flex flex-row justify-between items-center w-full"
          >
            <!-- Left side: label -->
            <div
              class="bg-yellow-180 text-yellow-800 text-xs font-medium inline-flex items-center px-2.5 py-1 rounded-md dark:bg-yellow-900 dark:text-yellow-300"
            >
              Top {{ cropTypesCount < 5 ? cropTypesCount : 5 }} Crop Types
            </div>

            <!-- Right side: icon -->
            <svg
              class="w-5 h-5 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white cursor-pointer"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
              (click)="downloadCropET()"
            >
              <path
                fill-rule="evenodd"
                d="M13 11.15V4a1 1 0 1 0-2 0v7.15L8.78 8.374a1 1 0 1 0-1.56 1.25l4 5a1 1 0 0 0 1.56 0l4-5a1 1 0 1 0-1.56-1.25L13 11.15Z"
                clip-rule="evenodd"
              />
              <path
                fill-rule="evenodd"
                d="M9.657 15.874 7.358 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.358l-2.3 2.874a3 3 0 0 1-4.685 0ZM17 16a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>

      <!-- Centered Crop Bar Chart -->
      <div class="flex-1 self-stretch my-auto">
        <div
          #cropBarChart
          id="crop-bar-chart"
          class="bg-white rounded-lg dark:bg-gray-800"
        ></div>
      </div>
    </div>

    <!-- Fields Summary -->
    <div
      class="flex flex-col flex-1 bg-white dark:bg-gray-800 rounded-lg col-span-3 p-4"
    >
      <div class="flex flex-col gap-3">
        <!-- Top Row: justify between -->
        <div class="flex justify-between items-center">
          <!-- Left content -->
          <div class="flex items-center">
            <h5
              class="text-sm 3xl:text-xl font-bold leading-none text-gray-900 dark:text-white pe-1"
            >
              {{ displayFieldsStatus ? "Fields" : "Acres" }} Summary
            </h5>
            <app-graph-popover-instruction [customSVG]="infoSVG">
              <div class="p-3 space-y-2">
                <h3 class="font-semibold text-gray-900 dark:text-white">
                  How To Use:
                </h3>
                <ul class="space-y-2 text-gray-700 dark:text-gray-400">
                  <li>
                    <strong>Acres Distribution</strong>
                    <p>
                      Click the
                      <span class="inline-flex"
                        ><ng-container *ngTemplateOutlet="acresSVG"
                      /></span>
                      Acres button to view the acreage of claimed and unclaimed
                      fields in your management area.
                    </p>
                  </li>
                  <li>
                    <strong>Fields Distribution</strong>
                    <p>
                      Click the
                      <span class="inline-flex"
                        ><ng-container *ngTemplateOutlet="fieldsSVG"
                      /></span>
                      Fields button to view the count of claimed and unclaimed
                      fields in your management area.
                    </p>
                  </li>
                </ul>
              </div>
            </app-graph-popover-instruction>
          </div>
          <!-- Right content -->
          <div class="flex items-center">
            <div class="inline-flex rounded-md shadow-xs" role="group">
              <button
                type="button"
                class="inline-flex items-center gap-2 px-3 py-1 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white"
                (click)="switchStatus('Acres')"
              >
                <ng-container *ngTemplateOutlet="acresSVG" />
                Acres
              </button>
              <button
                type="button"
                class="inline-flex items-center gap-2 px-3 py-1 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white"
                (click)="switchStatus('Fields')"
              >
                <ng-container *ngTemplateOutlet="fieldsSVG" />
                Fields
              </button>
            </div>
          </div>
        </div>

        <!-- Left side: label -->
        <div
          class="w-fit px-2.5 py-1 bg-green-200 text-green-800 text-xs font-medium rounded-md dark:bg-green-900 dark:text-green-300"
        >
          Claimed Rate:
          {{
            displayFieldsStatus ?
              ((claimedFieldsCount / totalFieldsCount) * 100).toFixed(2)
            : ((totalClaimedAcres / totalAcres) * 100).toFixed(2)
          }}
          %
        </div>
      </div>

      <!-- Centered Donut Chart -->
      <div class="flex-1 self-stretch my-auto">
        <div
          #summaryChart
          id="donut-chart"
          class="bg-white rounded-lg dark:bg-gray-800"
        ></div>
      </div>
    </div>
  </div>

  <!-- Total ET/Precip/Cumulative ET Chart -->
  <!-- 3xl:min-h-96 -->
  <div
    class="flex-[0.57] flex flex-col gap-1.5 shadow-lg rounded-lg bg-white dark:bg-gray-800"
  >
    <!-- Chart area -->
    <div
      class="flex-1 flex flex-col px-2 pt-2 3xl:px-6 p-4 md:p-6 pb-0 md:pb-0"
    >
      <!-- First Line: Title, Perennial Button, Time Filter -->
      <div class="flex justify-between">
        <!-- title, and isPerennialTree button -->
        <h6
          class="leading-none text-center text-base 3xl:text-xl font-bold text-gray-900 dark:text-white"
        >
          ET & Precipitation in {{ title }}
        </h6>

        <div class="flex flex-row items-center gap-4">
          <div class="relative">
            <!-- Dropdown Button -->
            <button
              #dropdownButton
              id="dropdownDefaultButton"
              class="text-sm w-full h-full font-medium text-gray-500 dark:text-gray-400 hover:text-gray-900 text-center inline-flex items-center dark:hover:text-white"
              type="button"
              (click)="toggleDropdown()"
            >
              {{ timeRange }}
              <svg
                class="w-2.5 m-2.5 ms-1.5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
            </button>
            <!-- Dropdown menu -->
            <div
              #dropdownMenu
              id="lastDaysdropdown"
              [class.hidden]="!isOpen"
              [class.block]="isOpen"
              class="absolute -left-20 top-8 z-50 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700"
            >
              <ul
                class="py-2 text-sm text-gray-700 dark:text-gray-200"
                aria-labelledby="dropdownDefaultButton"
              >
                <li
                  class="cursor-pointer"
                  (click)="onTimeFilterChange('Last 7 days')"
                >
                  <a
                    class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                    >Last 7 days</a
                  >
                </li>
                <li
                  class="cursor-pointer"
                  (click)="onTimeFilterChange('Last 15 days')"
                >
                  <a
                    class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                    >Last 15 days</a
                  >
                </li>
                <li
                  class="cursor-pointer"
                  (click)="onTimeFilterChange('Last 30 days')"
                >
                  <a
                    class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                    >Last 30 days</a
                  >
                </li>
                <li
                  class="cursor-pointer"
                  (click)="onTimeFilterChange('Last 60 days')"
                >
                  <a
                    class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                    >Last 60 days</a
                  >
                </li>
                <li
                  class="cursor-pointer"
                  (click)="onTimeFilterChange('All Water Year')"
                >
                  <a
                    class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                    >All Water Year</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- Download buttons -->
          <button
            title="Download time-series data as CSV"
            class="uppercase text-xs 3xl:text-sm font-semibold inline-flex gap-1 items-center rounded-lg bg-blue-600 text-white hover:bg-blue-700 dark:focus:ring-gray-700 px-2 py-1 3xl:px-3 3xl:py-2"
            (click)="downloadET()"
          >
            DOWNLOAD DATA
            <svg
              class="w-6 h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2m-8 1V4m0 12-4-4m4 4 4-4"
              />
            </svg>
          </button>
        </div>
      </div>

      <!-- Second Line: Chart Area -->
      <div
        id="labels-chart-container"
        class="flex-1 self-stretch my-auto relative"
      >
        <div #chart id="labels-chart"></div>
        <app-graph-popover-instruction
          class="absolute z-10 right-14 top-0.5"
          [useDefaultContent]="true"
        />
      </div>
    </div>
  </div>
</div>
